/* eslint-disable no-irregular-whitespace */
import Gongan from '@/assets/images/gongan.png'

export default () => {
  return (
    <>
      <div className={'bg-black h-13 text-center py-2 text-white w-full'}>
        <section
          className={
            'Projectcenter flex items-center justify-center flex-wrap h-auto'
          }
          style={{ height: '52px' }}
        >
          <span className="sm:text-sm  text-[10px]">
            Copyright&ensp;©&ensp;2025
            中科紫东太初（北京）科技有限公司&ensp;-&ensp;
            <span
              className="sm:text-sm  text-[10px] cursor-pointer"
              onClick={() =>
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
              }
            >
              京ICP备2025132495号-1&ensp;
            </span>
          </span>
          <span
            className="sm:text-sm  text-[10px] cursor-pointer flex items-center"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() =>
              window.open(
                'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802046008',
              )
            }
          >
            <img
              src={Gongan}
              alt=""
              style={{
                margin: '0 3px 0 8px',
                width: '18px',
                height: '18px',
                verticalAlign: 'text-bottom',
              }}
            />
            京公网安备11010802046008号
          </span>
        </section>
      </div>
    </>
  )
}
